import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';

type TrackEventFn = (
  appId: number,
  email: string,
  category: string,
  name: string,
  value: string,
  label: string | null,
) => Promise<unknown>;

// TODO: Currently not made async due to original fire & forget style implementation. Discuss if this is desireable or if it is prefered to let calling component decide on void implmentation.
// Fire-and-forget analytics event. `category` distinguishes content type ('collateral', 'videos', etc.). */
export function trackEvent(category: string, type: string, value: string, title: string): void {
  void (DataHandler.matchAppId() as Promise<number>).then((appId) => {
    void (StorageHandler.load(storageKeys.user) as Promise<{ email?: string } | null>).then((userObj) => {
      const email = userObj?.email ?? 'Guest';
      void (APIHandler.trackEvent as TrackEventFn)(appId, email, category, type, value, title);
    });
  });
}
